import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { AssessmentSessionForStatsDateResponse } from '../../models/session.types';

interface SessionListProps {
  sessions: AssessmentSessionForStatsDateResponse[];
  selectedSession: AssessmentSessionForStatsDateResponse;
  onChange: (event: SelectChangeEvent<string>) => void;
}

export const SessionsList: React.FC<SessionListProps> = ({ sessions, selectedSession, onChange }) => {
  return (
    <>
      <FormControl
        style={{ width: '370px', position: 'relative', top: '55px', right: '55px', textAlign: 'left' }}
        size="small"
      >
        <InputLabel>Wybierz sesję oceniania</InputLabel>
        <Select
          variant="outlined"
          label="Wybierz sesję oceniania"
          value={selectedSession.examSessionId}
          onChange={(event) => onChange(event)}
          inputProps={{
            color: '#000000',
            padding: '5px',
          }}
        >
          {sessions.map((session) => (
            <MenuItem disableRipple key={session.examSessionId} value={session.examSessionId}>
              Sesja oceniania:&nbsp;
              <span>
                <b>{session.examSessionName}</b>
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};
